var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-container',{staticClass:"px-0",attrs:{"fluid":""}},[_c('div',{staticClass:"d-flex"},[_c('sidebar',{staticClass:"esg-sidebar"}),_c('div',{staticClass:"esg-main"},[_c('top-bar',{staticClass:"esg-top-bar"}),_c('keep-alive',{attrs:{"max":2,"include":/List$/}},[_c('router-view',{key:_vm.$route.path,staticClass:"esg-router-view"})],1)],1)],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }